export const ARTICLE_PAGE_I18N = {
  en: {
    BACK_TO_ALL_STORIES: 'Back to all stories',
    LAND_ACKNOWLEDGMENT: 'Land acknowledgement',
    ABOUT_TELUS: 'About TELUS',
    CONTACTS: 'For more information, please contact:',
    RETURN_TO_PRESS_RELEASES: 'Return to press releases',
  },
  fr: {
    BACK_TO_ALL_STORIES: 'Retour à toutes les histoires',
    LAND_ACKNOWLEDGMENT: 'Reconnaissance foncière',
    ABOUT_TELUS: 'À propos de TELUS',
    CONTACTS: 'Pour en savoir plus, veuillez communiquer avec:',
    RETURN_TO_PRESS_RELEASES: 'Retour aux communiqués de presse',
  },
}
